export const LANDING = "/";
export const ABOUT = "/about";
export const WHATS_APP = "/project/whatsapp";
export const STAR_GAME = "/project/star-game";
export const ANALOG_CLOCK = "/project/analog-clock";
export const GITHUB = "/project/github";
export const URL_SHARE = "/project/urlshare";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const HOME = "/home";
export const ACCOUNT = "/account";
export const ADMIN = "/admin";
export const PASSWORD_FORGET = "/pw-forget";
